import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { WarehouseCardProductRecord as T } from 'types/ware-house-card-product.type';
import { getQueryParams } from 'utils';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/warehouse-cards`;
const tagType = TAG_TYPES.WarehouseCard;

const WarehouseCardApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllWarehouseCards: builder.query<
      {
        data: {
          rows: T[];
          count: number;
          kpis: {
            totalExport: number;
            totalImport: number;
            totalRemain: number;
          };
        };
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        if (query === '') return { url: urlEndpoint, method: 'GET' };
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),
  }),
});

export const { useGetAllWarehouseCardsQuery } = WarehouseCardApiService;
